import type { ReactNode } from "react";
import type { DialogProps } from "@radix-ui/react-dialog";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogSideContent,
  DialogSideHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface DialogCustomProps extends DialogProps {
  title?: string;
  description?: ReactNode;
  className?: string;
  startIcon?: ReactNode;
  side?: boolean;
}

const DialogCustom = ({
  title,
  description,
  className,
  startIcon,
  side = false,
  ...props
}: DialogCustomProps) => {
  return (
    <Dialog {...props}>
      {side ? (
        <DialogSideContent className={className}>
          <DialogSideHeader>
            {startIcon}
            <div className="flex flex-col w-full gap-2">
              {title && <DialogTitle>{title}</DialogTitle>}
              {description && (
                <DialogDescription>{description}</DialogDescription>
              )}
            </div>
          </DialogSideHeader>

          {props.children}
        </DialogSideContent>
      ) : (
        <DialogContent className={className}>
          <DialogHeader>
            {startIcon}
            <div className="flex flex-col w-full gap-2">
              {title && <DialogTitle>{title}</DialogTitle>}
              {description && (
                <DialogDescription>{description}</DialogDescription>
              )}
            </div>
          </DialogHeader>

          {props.children}
        </DialogContent>
      )}
    </Dialog>
  );
};

export default DialogCustom;
